// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__30-zl","search":"Settings_search__itjVp","filter":"Settings_filter__1Nkk_"};